import { remove } from '@/api/favicon.api'
import useAPI from '../useAPI'

export default (params = {}) => useAPI({
  request: remove,
  params
})
